import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import Button from '@eversports/klimt-primitives/legacy/Button'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Processing from '@eversports/klimt-primitives/legacy/Processing'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import AddFriendIcon from '../../../../../../assets/icons/add-friends.svg'
import { useAddToFriendsButtonRequestFriendshipMutation } from '../../../../../../graphql'
import { Localized } from '../../../../../../localization/react'

interface Props {
  publicUserId?: string
}

const AddToFriendsButton = ({ publicUserId }: Props) => {
  const { amplitude } = useAmplitude()
  const [addToFriends, { loading }] = useAddToFriendsButtonRequestFriendshipMutation({
    variables: { userId: publicUserId! },
  })

  const handleClick = () => {
    if (amplitude) {
      amplitude.logEvent('Clicked Add Friend Button')
    }
    void addToFriends()
  }

  return (
    <Processing isLoading={loading}>
      <Button
        variant="primary"
        sx={{ textTransform: 'none', paddingY: { xs: 3, md: 2 }, paddingX: 6, width: 'fit-content' }}
        onClick={handleClick}
      >
        <Stack alignItems="center" direction="row" gap={2}>
          <Icon size="small" color="white" src={AddFriendIcon} />
          <Text sx={{ color: 'white', fontWeight: 'bold' }}>
            <Localized id="add-to-friends-button-text" />
          </Text>
        </Stack>
      </Button>
    </Processing>
  )
}

export default AddToFriendsButton
